import { useEffect, useState } from "react";
import api, { apiError, fmtUSD } from "../../lib/api";
import { toast } from "sonner";

export default function Distributions() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/portfolio/distributions").then((r) => setData(r.data)).catch(() => setData({ rows: [], by_company: {}, total: 0, dpi: 0 }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async () => {
    try {
      const res = await api.get("/portfolio/distributions.pdf", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = "solera-distributions-ledger.pdf"; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiError(e)); }
  };

  if (!data) return <span className="t-label">Loading</span>;
  const companies = Object.entries(data.by_company).sort((a, b) => b[1] - a[1]);

  return (
    <div className="rise" data-testid="distributions-page">
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div>
          <span className="t-label">Distributions</span>
          <h1 className="t-h1 text-bone mt-3">Distributions ledger</h1>
        </div>
        {data.rows.length > 0 && (
          <button onClick={download} className="btn-ghost" data-testid="download-distributions-button">Download summary</button>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mt-10">
        <div><span className="t-label">Total distributions</span><p className="fig text-bone text-2xl mt-1">{fmtUSD(data.total)}</p></div>
        <div><span className="t-label">DPI</span><p className="fig text-bone text-2xl mt-1">{data.dpi ? data.dpi.toFixed(2) : "0.00"}</p></div>
        <div><span className="t-label">Companies</span><p className="fig text-bone text-2xl mt-1">{companies.length}</p></div>
      </div>

      {companies.length > 0 && (
        <div className="mt-12">
          <span className="t-label">By company</span>
          <div className="mt-3 max-w-xl">
            {companies.map(([c, amt]) => (
              <div key={c} className="hairline py-3 flex justify-between gap-6" data-testid={`dist-company-${c}`}>
                <span className="t-small text-bone">{c}</span>
                <span className="fig t-small text-bone">{fmtUSD(amt)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <table className="table-solera mt-12" data-testid="distributions-table">
        <thead><tr><th>Company</th><th>Tranche</th><th>Date</th><th className="num">Amount</th></tr></thead>
        <tbody>
          {data.rows.map((r, i) => (
            <tr key={`${r.company}-${r.tranche}-${r.date}-${i}`}>
              <td className="text-bone">{r.company}</td>
              <td className="text-muted-s">{r.tranche}</td>
              <td className="text-muted-s">{r.date}</td>
              <td className="num text-bone">{fmtUSD(r.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.rows.length === 0 && <p className="t-small text-muted-s mt-6">No distributions recorded yet.</p>}
    </div>
  );
}
